import { Field } from './Field';
import { DefaultDataValue } from './DefaultDataValue';
import { ValueIsProperty } from '../location-attribute.model';
export class Step {
    StepId: string;
    StepName: string;
    Fields: Field[];
    MultiFieldName: string;
    DefaultDataValues: DefaultDataValue[];
    IsMultiStep: boolean;
    HasRecursiveMultiples: boolean;
    FieldBasedAvailability: ValueIsProperty[];
    IsAvailableForSwift: boolean;
}
